"use client";

import { Code2Icon } from "lucide-react";

import type { CodeContentBlock } from "../../types";
import { truncate } from "../../utils";
import { CollapsibleSection } from "../CollapsibleSection";

interface CodeBlockProps {
  block: CodeContentBlock;
  isStreaming?: boolean;
}

export const CodeBlock = ({ block, isStreaming }: CodeBlockProps) => {
  const lines = block.code.split("\n");
  const previewLines = lines.slice(0, 3).map((l) => truncate(l));
  const preview = previewLines.join(" | ") + (lines.length > 3 ? " ..." : "");

  return (
    <CollapsibleSection
      icon={<Code2Icon className="h-3 w-3" />}
      label="Code"
      preview={preview}
      copyContent={block.code}
      isStreaming={isStreaming}
    >
      <pre className="overflow-x-auto rounded-md bg-zinc-100 p-2 text-xs text-zinc-800">
        {block.code}
      </pre>
    </CollapsibleSection>
  );
};
